const ThroneAndLibertyModel = {};

ThroneAndLibertyModel['America West'] = [
  'Akidu',
  'Invoker',
  'Moonstone',
  'Oblivion',
];

ThroneAndLibertyModel['America East'] = [
  'Adrenaline',
  'Carnage',
  'Ivory',
  'Pippin',
  'Snowburn',
  'Stellarite',
];

ThroneAndLibertyModel['South America'] = [
  'Chamir',
  'Eldritch',
  'Resistance',
  'Starlight',
];

ThroneAndLibertyModel.Europe = [
  'Arcane',
  'Cascade',
  'Conviction',
  'Destiny',
  'Emerald',
  'Fortune',
  'Judgment',
  'Obsidian',
  'Paola',
  'Rebellion',
  'Talon',
  'Zephyr',
];

ThroneAndLibertyModel['Japan & Oceania'] = [
  'Amethyst',
  'Sunstorm',
  'Titanspine',
  'Valkarg',
];

// eslint-disable-next-line import/prefer-default-export
export { ThroneAndLibertyModel };
